import type { FaireProductEntity } from "../../entity_types/product";

export const p_yhz68jcs24: FaireProductEntity = {
  token: "p_yhz68jcs24",
  type: "product",
  name: "Gorgeous 18K Gold Plated Cross Necklace – Meaningful Jewelry",
  brandToken: "b_rj5w53dbnq",
  brandName: "Sacred Sparkle Jewelry and Accessories for Women",
  imageUrl:
    "https://cdn.faire.com/fastly/e2288e914707ab180a9eee469709c1989fa6a0afa0a3895364e4b68f81c9392e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2b3a495de09f441cf954a6b94c50c10e8f825bbb030aeacc95aa99dd21c4990.png",
    "https://cdn.faire.com/fastly/44bc40f956dbac24de952763ad3b765ee4cbb9a3729e15a69e825383849674c9.jpeg",
  ],
  priceDollars: 5.2,
  description:
    "Observe the beauty of this cross crown necklace.Inspired by the Bible and Jesus who is a symbol of love and freedom.\nThis beautifully crafted religious and meaningful gold cross necklace is adorned in cubic zirconia and dipped in 18k gold and titanium steel as base metal.\n\nElevates any outfit gives all your looks an elegant style.Wear a tee and jeans or a dress for date night.A gift for graduation, birthdays, or just because.\n\nPerfect for bookstores, fashion boutiques, tourist gift shops, popups, hospital shops, church boutiques, tik tok shops or faith-based shops.This Christian necklace will add elegance you will be sure to feel.A great reminder of who is always for you...Jesus\n\n*This is one individual 18k Gold necklace with cross pendent included.",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:01.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
